import { useState, useContext, useEffect } from 'react'
import { IntakeContext } from '../context/IntakeContext'
import { toast } from 'react-toastify'
import { Box, Grid, Typography } from '@mui/material'
import { format, subYears, differenceInYears } from 'date-fns'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { useFieldFocus } from 'context/FieldFocusContext'
import { WheelSelector } from './WheelSelector'

const OnboardingAge = () => {
  const { intakeState, updateIntakeStateAtKey } = useContext(IntakeContext)

  const dateToYears = intakeState.dateOfBirth
    ? differenceInYears(new Date(), new Date(intakeState.dateOfBirth))
    : ''
  const yearsToDate = (years) =>
    format(subYears(new Date(), years), 'yyyy-MM-dd')

  const [isMobile, setIsMobile] = useState(window.innerWidth < 600)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600)
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const fieldId = 'fieldHelp'
  const newHelpText = `Field Help Text`
  const { handleFocus, handleBlur, registerHelpField } = useFieldFocus()
  useEffect(() => {
    registerHelpField(fieldId, newHelpText)
    updateIntakeStateAtKey({
      dateOfBirthYearsBased: true,
      hyperOnboarding: true,
    })
  }, [fieldId])

  return (
    <Box sx={{ textAlign: 'left' }}>
      {/* <Box
        onMouseEnter={(e) => handleFocus(fieldId, e.currentTarget)}
        onMouseLeave={() => handleBlur()}
      > */}
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          How old are you?
        </Typography>
      </Box>
      <Typography
        variant="body1"
        sx={{ lineHeight: '1.2' }}
        fontSize={{ xs: '16px', sm: '20px' }}
      >
        This helps us calculate your earliest retirement date
      </Typography>
      {/* </Box> */}
      <Grid container columnSpacing={3} mt={2}>
        <Grid item xs={12} mb={2}>
          {isMobile ? (
            <>
              <Grid item xs={12}>
                <WheelSelector
                  options={Array.from({ length: 101 }, (_, i) => i)} // 0..100
                  initialValue={dateToYears}
                  onChange={(val) => {
                    updateIntakeStateAtKey({
                      dateOfBirth: yearsToDate(val),
                    })
                  }}
                  visibleCount={20}
                  optionItemHeight={40}
                  width={300}
                  formatter={(val) => `${val}`}
                  suffixText="years old"
                  suffixGap={8}
                />
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={12}>
                {renderMuiFormField({
                  showAdornment: true,
                  required: true,
                  inputType: 'int',
                  id: 'dateOfBirth',
                  label: 'Age',
                  value: dateToYears,
                  enableHelpText: true,
                  onChange: (e) => {
                    updateIntakeStateAtKey({
                      dateOfBirth: yearsToDate(e),
                    })
                  },
                })}
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
export default OnboardingAge
